//@flow
import {
  DOMAIN,
  CONFIRM_EMAIL_RESOURCE,
  CONFIRM_EMAIL_REQUEST,
  CONFIRM_EMAIL_SUCCESS,
  CONFIRM_EMAIL_FAILED,
  RESEND_LINK_RESOURCE,
  RESEND_LINK_REQUEST,
  RESEND_LINK_SUCCESS,
  RESEND_LINK_FAILED
} from './constants'
import {
  startCommunication,
  endCommunication,
  isCommInProgress
} from '../../modules/communication'
import { batch } from '../../modules/lib/batchReducer'
import { services } from '../../core/feathers'
import { domains } from '../constants'
import { hset, hmset } from '../../modules/hash'
import { getUserId } from '../session'
import type { ThunkAction } from '../../core/types'

export function confirmEmail(token: String): ThunkAction {
  return async function(dispatch, getState) {
    const resource = CONFIRM_EMAIL_RESOURCE
    if (isCommInProgress(resource, getState())) {
      return false
    }
    dispatch(batch(CONFIRM_EMAIL_REQUEST, startCommunication(resource)))
    try {
      const result = await services.emailVerification.patch(token, {
        verifiedAt: Date.now()
      })
      // console.log('Email verified result', result)
      dispatch(
        batch(
          CONFIRM_EMAIL_SUCCESS,
          hmset(domains.SESSION, result),
          endCommunication(resource, true)
        )
      )
      return true
    } catch (error) {
      console.warn('Error verifying email', error.message)
      dispatch(batch(CONFIRM_EMAIL_FAILED, endCommunication(resource, false)))
      return false
    }
  }
}

function setVerificationSent(isSent: boolean) {
  return hset(DOMAIN, 'linkSent', isSent)
}

export function resendLink(): ThunkAction {
  const resource = RESEND_LINK_RESOURCE
  return async function(dispatch, getState) {
    const userId = getUserId(getState())
    if (!userId) throw new Error('User not logged in')
    if (isCommInProgress(resource, getState())) {
      return
    }
    dispatch(batch(RESEND_LINK_REQUEST, startCommunication(resource)))
    try {
      const result = await services.emailVerification.create({
        userId
      })
      dispatch(
        batch(
          RESEND_LINK_SUCCESS,
          setVerificationSent(true),
          endCommunication(resource, true)
        )
      )
      console.log('Created new email verification', result)
      return true
    } catch (err) {
      console.log('Error resending link', err)
      dispatch(
        batch(
          RESEND_LINK_FAILED,
          setVerificationSent(false),
          endCommunication(resource, false)
        )
      )
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/email-verification/actions.js